/** Office call logs directory — shared by CallLogsTable and OfficeCallLogFilters. */
export const CALL_LOG_COLUMN_DEFS = [
  { id: "date", label: "Date", defaultVisible: true },
  { id: "time", label: "Time", defaultVisible: true },
  { id: "caller_name", label: "Caller Name", defaultVisible: true },
  { id: "phone", label: "Phone", defaultVisible: true },
  { id: "call_type", label: "Call Type", defaultVisible: true },
  { id: "purpose", label: "Purpose", defaultVisible: true },
  { id: "action", label: "Action", defaultVisible: true },
  { id: "status", label: "Status", defaultVisible: true },
  { id: "handled_by", label: "Handled By", defaultVisible: true },
  { id: "follow_up", label: "Follow-up Date", defaultVisible: true },
  { id: "follow_up_assigned_to", label: "Follow-up assigned to", defaultVisible: true },
  { id: "duration", label: "Duration", defaultVisible: true },
  { id: "remarks", label: "Remarks", defaultVisible: false },
  { id: "actions", label: "Actions", defaultVisible: true },
];
